(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      //Ak custom code
      const sticky_announcement = document.querySelector('.announcement-bar-section .enable_sticky');
      //Ak custom code

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        //Ak custom code
        if(sticky_announcement){
          sticky_announcement.closest('.announcement-bar-section').classList.add('sticky_announcement');
        }
        //End Ak custom code

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        //Ak custom code
        if(sticky_announcement){
          sticky_announcement.closest('.announcement-bar-section').classList.add('sticky_announcement');
        }
        //End Ak custom code

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');

        //Ak custom code
        if(sticky_announcement){
          sticky_announcement.closest('.announcement-bar-section').classList.remove('sticky_announcement');
        }
        //End Ak custom code

        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  //Ak custom code
  function updateAnnouncementTop() {
    const header = document.querySelector('.shopify-section-header-sticky');
    const announcement = document.querySelector('.announcement-bar-section.sticky_announcement');

    if (!header || !announcement) return;

    announcement.style.top = header.offsetHeight + 'px';
  }

  // FD: throttle to one update per frame and mark the scroll listener passive so it never blocks scrolling
  let fdAnnounceQueued = false;
  function queueAnnouncementTop() {
    if (fdAnnounceQueued) return;
    fdAnnounceQueued = true;
    requestAnimationFrame(() => { fdAnnounceQueued = false; updateAnnouncementTop(); });
  }
  document.addEventListener('DOMContentLoaded', updateAnnouncementTop);
  window.addEventListener('resize', queueAnnouncementTop, { passive: true });
  window.addEventListener('scroll', queueAnnouncementTop, { passive: true });
  //End Ak custom code


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector('#shopify-section-{{ section.id }}');
  if (!section) return;

  const track = section.querySelector('#Slider-{{ section.id }}');
  const slides = track ? track.querySelectorAll('.testimonial-slide') : [];
  const prevButton = section.querySelector('.testimonial-arrow--prev');
  const nextButton = section.querySelector('.testimonial-arrow--next');

  if (!track || slides.length === 0 || !prevButton || !nextButton) return;

  let currentIndex = 0;

  function showSlide(index) {
    if (!track || slides.length === 0) return;
    track.scrollTo({
      left: slides[index].offsetLeft,
      behavior: 'smooth'
    });
  }

  nextButton.addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  });

  prevButton.addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(currentIndex);
  });
});

  } catch(e) { console.error(e); }
})();
})();
